import find from "lodash/find";

export type ActiveRect = { left: number; top: number; width: number; height: number };

export type DropZone = { id: string; getRect: () => DOMRect | null };

export const getActiveDropZone = (activeRect: ActiveRect | null, zones: DropZone[]): string | null => {
  if (!activeRect) {
    return null;
  }
  const activeRight = activeRect.left + activeRect.width;
  const activeBottom = activeRect.top + activeRect.height;

  const hitZone = find(zones, (zone) => {
    const rect = zone.getRect();
    return (
      rect !== null &&
      activeRect.left < rect.right &&
      activeRight > rect.left &&
      activeRect.top < rect.bottom &&
      activeBottom > rect.top
    );
  });

  return hitZone?.id ?? null;
};
